import {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {useFetch} from '../useFetch'
import {useApp} from '../../contexts/AppContext'
import {useAuth} from '../../contexts/AuthContext'

import {CONFIG} from '../../config'
import {AuthInfo} from '../../types/contexts/AuthContext'
import {OAuth2Credentials} from '../../types/user/auth'
import {ApiError} from '../../types/exception/errorStatus'
import {getErrorMessage} from '../../utils/exception/exceptionUtils'

export function useOAuth2Authentication() {
    const {t} = useTranslation('exceptions')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const {poster} = useFetch()
    const {saveAuthInfo} = useAuth()
    const {lang, theme} = useApp()

    const resetState = () => {
        setLoading(false)
        setError(null)
    }

    /** Resolves to true once the user is signed in, false if the sign-in failed (the error is in `error`). */
    const login = async (oAuth2Credentials: OAuth2Credentials): Promise<boolean> => {
        setLoading(true)
        try {
            const data = await poster<AuthInfo>(
                `${CONFIG.BOUNCE_API}/api/v1/auth/oauth2`,
                {...oAuth2Credentials, language: lang, theme: theme.toUpperCase()},
                'application/json'
            )
            if (data) {
                saveAuthInfo(data)
                setError(null)
                return true
            }
            return false
        } catch (error) {
            console.log(error)
            if (error instanceof ApiError) {
                const translatedMessage = getErrorMessage(error.data)
                setError(translatedMessage)
            } else setError(t('exceptions:unknown'))
            return false
        } finally {
            setLoading(false)
        }
    }

    return {login, loading, error, resetState}
}
